<template>
    <div v-if="loading">
        <vx-card>
            <h3> Loading... Please wait...</h3>
        </vx-card>
    </div>
    <vx-card v-else>
        <div class="vx-row">
            <div class="vx-col w-full mb-3">
                <vs-input
                    class="w-full" 
                    label="Demat Account Name" 
                    placeholder="Enter name of the Demat Account" 
                    v-model="demat_account.name"
                    :warning="api_errors.name"
                    :warning-text="api_errors.name?api_errors.name[0]:null"
                />
            </div>
            <div class="vx-col w-full mt-3 text-center">
                <vs-button 
                    color="primary" 
                    type="filled" 
                    @click.prevent="save"
                    :disabled="submit_disabled"
                >Save</vs-button>
            </div>
        </div>
    </vx-card>
</template>

<script>

import {Request} from "../../utils/requests"

export default {
    data() {
        return {
            loading: true,

            demat_account: {
                name: null,
            },
            demat_account_id: this.$route.params.demat_account_id,
            submit_disabled: false,
            api_errors: {}
        }
    },
    mounted() {
        this.init()
    },
    watch: {
        '$route.params.demat_account_id'(newV) {
            this.init()
        }
    },
    methods: {
        init() {
            this.demat_account_id = this.$route.params.demat_account_id
            if(this.demat_account_id){
                this.loadData()
            } else { 
                this.loading = false
                this.demat_account = {
                    name: null,
                }
            }
        },
        loadData() {
            this.loading = true
            this.$vs.loading()

            let url = this.$store.state.apiendpoints.demat_account + this.demat_account_id + "/"

            Request(this, 'GET', url).then(
                (res) => { 
                    this.demat_account = res
                    this.loading = false
                    this.$vs.loading.close()
                },
                (err) => {
                    this.$vs.notify({
                        time: 2500,
                        title: 'Unknown Error',
                        text: 'An Error Occured while loading data. Please Try Again',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                    this.loading = false
                    this.$vs.loading.close()
                    this.$router.push("/")
                }
            )
        },
        save(){
            let $this = this
            let url = $this.$store.state.apiendpoints.demat_account, request_method = 'POST'

            if(this.demat_account_id){
                url += this.demat_account_id + "/"
                request_method = 'PUT'
            }

            let data = {...this.demat_account}

            this.submit_disabled = true

            Request($this, request_method, url, null, data).then( 
                (res) => {
                    $this.$vs.notify({
                        time: 2500,
                        title: 'Saved',
                        text: 'Saved Successfully',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        color: 'success'
                    })
                    this.submit_disabled = false
                    $this.$router.push({name: 'demat-account-list'})
                },
                (err) => {
                    if(err.error) {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: 'Please check all fields and Try Again.',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                        this.api_errors = err.error
                    } else {
                        $this.$vs.notify({
                            time: 2500,
                            title: 'Unknown Error',
                            text: 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                    this.submit_disabled = false
                }
            )
        }
    }
}
</script>